const isEmptyPrintValue = value => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

const isDynamicPrintField = field => field.value?.startsWith("tech_passport_values_attributes");

const getIssuePrintBlocks = (blocks = [], row = {}, hideEmptyFields = false) =>
  blocks
    .map(block => ({
      ...block,
      parts: (block.parts || [])
        .map(part =>
          part.filter(
            field =>
              !hideEmptyFields ||
              (block.class !== "main-block" && !isDynamicPrintField(field)) ||
              !isEmptyPrintValue(row[field.value]),
          ),
        )
        .filter(part => part.length > 0),
    }))
    .filter(block => block.parts.length > 0);

const getPrintFiles = value => {
  if (!value) return [];
  return (Array.isArray(value) ? value : [value]).filter(file => file && typeof file === "object");
};

const getPrintFileName = file => file.file_name || file.name || "";
const isPrintImage = file => /^image\//i.test(file.content_type || file.type || "");

const getIssuePrintImageGroups = (blocks = [], row = {}) =>
  blocks.flatMap(block =>
    (block.parts || []).flat().flatMap(field => {
      if (field.type !== "file") return [];
      const files = getPrintFiles(row[field.value]).filter(file => isPrintImage(file) && file.url);
      return files.length ? [{ key: field.value, label: field.label, files }] : [];
    }),
  );

module.exports = {
  isEmptyPrintValue,
  getIssuePrintBlocks,
  getPrintFiles,
  getPrintFileName,
  getIssuePrintImageGroups,
};
